/**
 * Animated sun visual component.
 *
 * Renders a glowing circle whose color shifts from soft gold (low UV) to pure
 * white (extreme UV) and whose glow radius scales with UV intensity.
 */
import React from 'react';
import './Sun.css';

const Sun = ({ uvIndex }) => {
  const getSunColor = () => {
    if (uvIndex === 0) return '#FFD700'; // Soft gold for no UV
    if (uvIndex <= 2) return '#FFE55C'; // Soft yellow for low UV
    if (uvIndex <= 5) return '#FFF4A3'; // Light yellow for moderate UV
    if (uvIndex <= 7) return '#FFF8DC'; // Very light yellow for high UV
    if (uvIndex <= 9) return '#FFFACD'; // Almost white for very high UV
    return '#FFFFFF'; // Pure white for extreme UV
  };

  const getSunIntensity = () => {
    return Math.min(uvIndex / 11, 1); // Normalize to 0-1 range
  };

  return (
    <div 
      className="sun"
      style={{
        backgroundColor: getSunColor(),
        opacity: 0.6 + (getSunIntensity() * 0.4), // More visible with higher UV
        boxShadow: `
          0 0 ${20 + (getSunIntensity() * 80)}px ${getSunColor()},
          0 0 ${40 + (getSunIntensity() * 160)}px ${getSunColor()},
          0 0 ${80 + (getSunIntensity() * 320)}px ${getSunColor()}
        `
      }}
    />
  );
};

export default Sun;